import styles from "./EmailContent.module.css";

const EmailContent = () => {
  return  <span className={styles.content}>You may now close this window</span>
} 
export default EmailContent;